<div class="organization-modal">
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title">{{ modalLabel }} </span>
    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal" [ngClass]="{ 'disabled-popup': !showEdit }">
    <form [formGroup]="prodUseForm">
      <div class="row">
        <div>
          <div>
            <h5>Product use process</h5>
          </div>

          <div class="row my-3">
            <div class="col-md-6">
              <div class="d-flex checkBoxAlienMent">
                <div>
                  <input
                    type="checkbox"
                    class="chkOverview"
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="isCustomProcess"
                    (change)="changeMaterialValue($event)"
                  />
                </div>
                <div>
                  <span class="checkbox-style"> Custom product use</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex justify-content-end">
                <div></div>
                <div>
                  <a class="add-link" target="_blank" routerLink="custom/customFilling"
                    ><span class="redirectLinkText">Add product use process</span></a
                  >
                  <a
                    class="setLinkIconPosition"
                    target="_blank"
                    replaceUrl="true"
                    routerLink="custom/customFilling"
                  >
                    <img src="./assets/icons/redirect-icon.svg" alt="" width="15" height="13" />
                  </a>
                  <span class="setLinkIconPosition" (click)="getCustomFillingList()"
                    ><img src="./assets/icons/refresh-circle.svg" alt="" width="14" height="13"
                  /></span>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div [ngClass]="!isCustomProcess ? 'col-md-6' : 'col-md-12'">
              <div class="form-group required">
                <label class="sub-header-drpdown">Product use process</label>
                <ng-select
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  #process
                  [items]="manufactureItems"
                  [searchable]="false"
                  bindLabel="name"
                  formControlName="processName"
                  [searchFn]="commonInputSearchForName"
                  placeholder="Product use process *"
                >
                  <ng-template ng-header-tmp>
                    <div class="has-feedback">
                      <input
                        type="text"
                        (input)="process.filter($any($event.target).value)"
                        class="form-control search-input search"
                        id="inputValidation"
                        placeholder="Search..."
                      />
                      <span class="form-control-feedback">
                        <i class="fa fa-search icon"></i>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                      {{ item?.name }}
                    </div>
                  </ng-template>
                </ng-select>
                <div *ngIf="submitForManufacture && prodUseForm.get('processName')?.errors">
                  <div *ngIf="prodUseForm.get('processName')?.invalid" class="input-error">
                    Please select energy process
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6" *ngIf="!isCustomProcess">
              <div class="form-group required" aria-required="true">
                <piqet-angular-common-input
                  label="Amount"
                  name="amount"
                  placeholder="Amount"
                  formControlName="amount"
                  [control]="prodUseForm.get('amount')"
                  [submitted]="submitForManufacture"
                  [maxLength]="100"
                  inputType="number"
                  [required]="true"
                  [preventNegative]="true"
                  (customBlur)="getCostPerPackage()"
                  [errorMessages]="{
                    nonNegative: 'Please enter a positive value.'
                  }"
                ></piqet-angular-common-input>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="isCostTrunOff && !isCustomProcess">
            <div class="col-md-6">
              <div class="form-group" aria-required="true">
                <piqet-angular-common-input
                  label="Cost per unit"
                  name="costPerUnit"
                  placeholder="Cost per unit"
                  formControlName="costPerUnit"
                  [control]="prodUseForm.get('costPerUnit')"
                  [maxLength]="100"
                  inputType="number"
                  [preventNegative]="true"
                  (customBlur)="getCostPerPackage()"
                ></piqet-angular-common-input>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group" aria-required="true">
                <piqet-angular-common-input
                  label="Cost per package (USD)"
                  name="costPerPackage"
                  placeholder="Cost per package (USD)"
                  formControlName="costPerPackage"
                  [control]="prodUseForm.get('costPerPackage')"
                  [maxLength]="100"
                  inputType="number"
                  [disabled]="true"
                ></piqet-angular-common-input>
              </div>
            </div>
          </div>
          <div class="commonBtnMarginForGrid text-margin">
            <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="addProcess()">
              {{ manufactureEditMode ? 'Update process' : 'Add process' }}
            </button>
          </div>

          <ng-container>
            <div id="divmanufactureofmaterialList" class="grid-div pb-4">
              <piqet-angular-portlet
                [class]="'overflowCheck'"
                [columnDefs]="!isCostTrunOff ? manufactureColumnDef : manufactureColumnDefForCost"
                [frameworkComponents]="frameworkComponents"
                [gridData]="manufactureGridData"
                [gridName]="'product use list'"
                [hidePagination]="true"
                [hideSearch]="true"
              >
              </piqet-angular-portlet>
            </div>
          </ng-container>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer text-margin">
    <button type="button" class="btn btn-light cancelBtn" (click)="onClose()">Cancel</button>
    <button
      type="button"
      class="modelBtn purpleBtnHoverEffect"
      [disabled]="!(manufactureGridData.length > 0)"
      *ngIf="showEdit"
      (click)="onSave()"
    >
      Save
    </button>
  </div>
</div>
